module.exports = __webpack_public_path__ + "static/img/1_2_1.eb5e50c6.png";